import type { Mesh, Object3D, SceneControl } from '@anov/3d-core'
import { Group } from '@anov/3d-core'
import ObjectLayer from '../Base/ObjectLayer'
import { StrategyManage as BubbleStrategy } from '../Poi/particle/index'
import { StrategyManage as LineStrategy } from './line'
import type { ButtleOption, LineOption, Option, PathItem } from './type'

const STYLE_DATA = {
  flyline_01: ['arc', 'doubleCircle'],
}
class Flyline extends ObjectLayer {
  _style: string
  _path: Array<object>
  _line: LineOption
  _bubble: ButtleOption

  _lineMesh: Array<Mesh> = []
  _bubbleMesh: Array<Mesh> = []
  _pointStrings = new Set()
  type = 'Group'

  public get style(): string {
    return this._style
  }

  public set style(value) {
    this._style = value
  }

  public get path(): Array<object> {
    return this._path
  }

  public set path(value) {
    this._path = value
  }

  public get line(): LineOption {
    return this._line || {}
  }

  public get bubble(): ButtleOption {
    return this._bubble || {}
  }

  constructor(params: Option, sceneControl: SceneControl) {
    super(sceneControl)
    const { style, path, line, bubble } = params
    this._style = style
    this._path = path
    this._line = line
    this._bubble = bubble

    this.init()
  }

  private async init() {
    const group = new Group()
    const [lineUri, bubbleUri] = STYLE_DATA[this.style]

    const BubbleClass = await BubbleStrategy[bubbleUri]()
    const LineClass = await LineStrategy[lineUri]()
    this.path.forEach(async (item: PathItem) => {
      const lineMesh = new LineClass({ ...this.line, startPoint: item.from, endPoint: item.to }, this.sceneControl)

      await lineMesh.ready
      this._lineMesh.push(lineMesh)
      group.add(lineMesh)
      this.addBubbleMesh(group, new BubbleClass({ radius: 0.5, ...this.bubble }, this.sceneControl), item.from)
      this.addBubbleMesh(group, new BubbleClass({ radius: 0.5, ...this.bubble }, this.sceneControl), item.to)
    })
    this.add(group)
    this._line = this.proxy(this._line, this._lineMesh)
    this._bubble = this.proxy(this._bubble, this._bubbleMesh)
  }

  private addBubbleMesh(parentNode: Group, mesh: Mesh, point: any) {
    if (this._pointStrings.has(JSON.stringify(point)))
      return
    this._pointStrings.add(JSON.stringify(point))
    mesh.position.fromArray(point)
    this._bubbleMesh.push(mesh)
    parentNode.add(mesh)
  }

  private proxy<T extends object>(obj: T, meshs: Array<Object3D>): T {
    return new Proxy(obj, {
      set: (target, prop, value) => {
        // @ts-ignore
        meshs.forEach(mesh => mesh[prop] = value)
        // @ts-ignore
        target[prop] = value
        return true
      },
    })
  }
}

export { Flyline }
